import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_buttonView/_layout/resources/_type')({
  staticData: {
    title: 'Resources',
    disableTitleLink: true,
  },
});
